module.exports = __webpack_public_path__ + "static/media/ic_pdf_upload_selected.17d0c1d6.svg";